import { ChangeDetectorRef, Directive, OnInit, effect, inject } from '@angular/core';
import { Logger } from '@df/core/service/logger';
import { SearchOutletComponentDef } from '@df/search/search-outlet.component.def';
import { getState } from '@ngrx/signals';
import { AdvancedCommerceSearchStore } from '../../store/advanced-commerce-search.store';

@Directive()
export class AdvancedCommerceSearchOutletComponentDef extends SearchOutletComponentDef implements OnInit {
    readonly store = inject(AdvancedCommerceSearchStore);
    protected logger = inject(Logger);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    constructor(_ref: ChangeDetectorRef) {
        super(_ref);

        // hack for detect changes in signals store
        effect(() => {
            // read store changes and update template
            const state = getState(this.store);
            this.logger.info('AC search state:', state);

            this.changeDetectorRef.detectChanges();
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.store.elementSet('autocomplete_home_recs');

        this.store.dataSet({
            template: 'autocomplete'
        });
    }
}
